import { render } from "./user_add.vue?vue&type=template&id=2ede9cc0"
import script from "./user_add.vue?vue&type=script&lang=js"
export * from "./user_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__